import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { ShipRoute } from "@zhihaoscm/entity";
import type { Page } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";
export class ShipRouteService extends BaseService<ShipRoute, any, any, any> {
    public async update(id: number | string, weight: number) {
        const { data } = await this.service.put(`${this.path}`, {
            id,
            weight
        });
        return data;
    }
    public async shipRouteSelector(params: {
        shipRouteName: string;
        sourceProvinceCode: string;
        sourceCityCode: string;
        sourceRegionCode: string;
    }): Promise<ShipRoute[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }
    public async getInfo(id: string | number): Promise<ShipRoute> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }
    public async pagingSelector(params: any): Promise<Page<ShipRoute>> {
        const { data } = await this.service.get(`${this.path}/paging-selector`, { params });
        return data;
    }

    public async getRouteByStartAndEnd(
        startPortId: string | number,
        endPortId: string | number
    ): Promise<Array<ShipRoute>> {
        const { data } = await this.service.get(`/ship/route/${startPortId}/${endPortId}`);
        return data;
    }

    @confirmable("是否删除，删除后该航线将不再展示")
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }
}
export const shipRouteService = new ShipRouteService("/dataService/admin/ship/route", request.service);
